import styled from 'styled-components';

import Modal from 'components/ui-components/Modal';
import Button from 'components/ui-components/Button';
import { CrossIcon } from 'assets/icons';
import { grey50, white } from 'constants/variables';

const ImageZoom = ({ image, modalIsOpen, closeModal }) => (
  <StyledModal
    className=""
    isOpen={modalIsOpen}
    closeModal={closeModal}
    config={{ backdropColour: white }}>
    <CloseIconButton handleClick={closeModal}>
      <CrossIcon fillColor={grey50} width={18} height={18} />
    </CloseIconButton>
    <StyledImageWrapper className="cef-modal__image-wrapper">
      <picture>
        <source srcSet={image.replace('.jpg', '.webp')} type="image/webp" />
        <ZoomImage src={image} alt="" />
      </picture>
    </StyledImageWrapper>
  </StyledModal>
);

const StyledModal = styled(Modal)`
  > div {
    width: 75%;
    margin: 0;
    position: relative;
    padding: 1rem;

    @media screen and (min-width: 768px) {
      height: auto;
      max-width: 800px;
      padding: 0;
    }
  }
`;

const StyledImageWrapper = styled.div`
  height: 100vh;
`;

const CloseIconButton = styled(Button)`
  border: 0;
  background-color: transparent;
  padding: 0;
  width: 44px;
  height: 44px;
  position: absolute;
  top: 22px;
  right: 22px;
  z-index: 10;
  background-color: white;
`;

// scale down image vertically + horizontally
const ZoomImage = styled.img`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
  max-width: 100%;
  max-height: 100%;
`;

export default ImageZoom;
